export default "__VITE_ASSET__jl5oYy8A__"